import { AfterContentInit, Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-citizen-id',
  templateUrl: './input-citizen-id.component.html',
  styleUrls: ['./input-citizen-id.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCitizenIdComponent),
      multi: true
    }
  ]
})
export class InputCitizenIdComponent extends FormControlBase<any> implements OnInit, AfterContentInit {
  @Input() id;
  @Input() label;
  @Input() groupClass?;
  @Input() inputClass?;
  @Input() labelClass?;
  @Input() isValidateDigit?;
  citizenIdMaxLength = 13;
  isBlurCitizenId = true;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) { super(cc); }

  get isInvalidMsg(): boolean {
    return (this.submitted && this.control.invalid)
      || (this.control.touched && this.control.invalid && (this.isBlurCitizenId || this.isCitizenIdMaxLength));
  }

  get isCitizenIdMaxLength(): boolean {
    return this.citizenIdValue.length === this.citizenIdMaxLength;
  }

  get citizenIdValue(): string {
    return this.control.value ? this.control.value : '';
  }

  ngOnInit() {
    this.checkInitialControl();
  }

  ngAfterContentInit(): void {
    if (this.isValidateDigit) {
      // todo wait
    }
  }

}
